import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Banknote,
  ClipboardCheck,
  CreditCard,
  FileText,
  Files,
  Landmark,
  ReceiptText,
  UsersRound,
  ChartNoAxesColumnIncreasing,
} from "lucide-react";

const useApprovals = () => {
  const onBudgetCardClick = () => {
    communityDetail?.communityId ? navigate(`${routes.budgetApprovals}`) : "";
  };

  const [cardList, setCardList] = useState<any>([
    {
      title: "Budget",
      description: "Review and approve community budgets.",
      icon: Banknote,
      onClick: onBudgetCardClick,
    },
    {
      title: "Invoice",
      description: "Review and approve invoices.",
      icon: FileText,
      onClick: () => navigate(`${routes.invoice}`),
    },
    {
      title: "Payment",
      description: "Review and manage payment approvals.",
      icon: CreditCard,
      onClick: () => navigate(`${routes.payment}`),
    },
    {
      title: "Billing",
      description: "Manage billing cycles and records.",
      icon: ReceiptText,
      onClick: () => navigate(`${routes.billing}`),
    },
    {
      title: "Collection",
      description: "Review collections and owner balances.",
      icon: UsersRound,
      onClick: () => navigate(`${routes.collection}`),
    },
    {
      title: "Clearing",
      description: "Manage clearing documents and activity.",
      icon: Files,
      onClick: () => navigate(`${routes.clearing}`),
    },
    {
      title: "General Ledger",
      description: "Review ledger entries and financial reports.",
      icon: Landmark,
      onClick: () => navigate(`${routes.generalLedger}`),
    },
    {
      title: "Audit",
      description: "Review audit records and activity.",
      icon: ClipboardCheck,
      onClick: () => navigate(`${routes.audit}`),
    },
    {
      title: "Cost Analytics",
      description: "Review cost data and analytics.",
      icon: ChartNoAxesColumnIncreasing,
      onClick: () => navigate(`${routes.costAnalytics}`),
    },
    // {
    //   title: "Incident",
    //   bgImg: InvoiceBg,
    //   className: "bg-primary",
    //   backgroundSize: "150px 150px",
    //   onClick: () => navigate(`${routes.incident}`),
    // },
  ]);

  const navigate = useNavigate();
  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  return {
    cardList,
    setCardList,
  };
};

export default useApprovals;
